import React from 'react';
import Table from 'UI/Table';
import CopiesTable from './CopiesTable';

const PoliciesTable = ({ storage_policies }) => (
  <Table
    data={storage_policies}
    pageSize={storage_policies.length}
    showPagination={false}
    columns={[
      { Header: 'Storage Policy', accessor: 'name' },
      { Header: 'Data Written', accessor: 'data_written_in_bytes', Cell: row => row.original.data_written },
      { Header: 'Non-Aged Data Written', accessor: 'non_aged_data_written_in_bytes', Cell: row => row.original.non_aged_data_written },
      { Header: 'Job Count', accessor: 'job_count', Cell: ({ value }) => parseInt(value).toLocaleString() }
    ]}
    SubComponent={({ original: { copies } }) => <CopiesTable {...{ copies }} />}
  />
);

export default PoliciesTable
